/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="businessTypes.module.ts" />

module Meevo.Plugins.BusinessTypes {
    class BusinessTypesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.ContextParams",

            "meevo.components.busy.BusyService",
            "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: any,
            protected $state: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected contextParams: Meevo.IContextParams,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService) {
                super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
                //this.createContext();
            }
        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.DATA_BUSINESSTYPE).then(() => {
                this.busyService.stop();
                this.context = new BusinessTypesContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                this.busyService.stop();
            });
        }
    }

    angular.module("meevo.plugins.businessTypes")
        .controller("meevo.plugins.businessTypes.BusinessTypesController", BusinessTypesController);
}